import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { ValidarLogin, ValidarEmisor } from '../../util';
import { logOut, getInventario, clearErrors } from '../../actions';
import InventarioForm from './InventarioForm';
import { Icon, Container } from 'semantic-ui-react';
import { messageTypeEnum } from '../../enum';
import BasicMessage from '../messages/basicMessage';
import { unidadMedida } from '../../catalogos';
import RenderHeader from '../shared/RenderHeader';

const Inventario = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);
  const { inventarioState } = props;
  const [productos, setProductos] = useState([]);
  const [producto, setProducto] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [mgType, setMgType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    props.clearErrors();

    if (token !== null && emisor !== null) {

      props.getInventario(token.access_token, emisor.Id, 10, 0);
    }

  }, []);

  useEffect(() => {
    if (inventarioState) {
      setProductos(inventarioState.Productos);
      if (inventarioState?.TotalRegistros < 1) {

        setMgType(messageTypeEnum.error);
        setMessage('No hay productos en el inventario');
      } else {
        setMgType('');
        setMessage('');

      }
    }

  }, [inventarioState]);

  const getInventario = () => {

    props.getInventario(token.access_token, emisor.Id, 10, 0);
    setProducto(null)

  }


  if (token === null || emisor === null) {
    return <Redirect to='/login' />;
  }
  const getUnidad = (value) => {

    if (value !== null) {
      return unidadMedida.filter((item) => item.value === value)[0].display;
    }
    return 'N/A';
  };

  const getNextPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    props.getInventario(token.access_token, emisor.Id, 10, pageNumber);
    setProducto(null)
  };

  const renderPaging = (totalRegistros) => {
    let totalPages = 0;
    const pages = [];
    if (totalRegistros > 10) {
      totalPages = totalRegistros / 10;
      let d = totalPages - Math.floor(totalPages);
      totalPages = d > 0 ? Math.floor(totalPages) + 1 : Math.floor(totalPages);

      for (let i = 1; i <= totalPages; i++) {
        pages.push(<a key={i} className="item" onClick={() => getNextPage(i)}>{i}</a>);
      }

      return (
        <tfoot>
          <tr><th colSpan="7">
            <div className="ui right floated pagination menu">

              {(1 < currentPage) && <a className="icon item" onClick={() => getNextPage(currentPage - 1)}>
                <i className="left chevron icon"></i>
              </a>}
              {pages.map(item => item)}
              {(totalPages > currentPage) && <a className="icon item" onClick={() => getNextPage(currentPage + 1)}>
                <i className="right chevron icon"></i>
              </a>}
            </div>
          </th>
          </tr>
        </tfoot>
      );
    }
    return (<tfoot />);
  };

  return (
    <Container className="ui row fluid inventario-content">

      <RenderHeader titulo="INVENTARIO" />

      <div className="ui column">
        <InventarioForm
          token={token}
          emisorId={emisor.Id}
          refresh={() => getInventario()}
          productoSelected={producto}
        />
      </div>

      <div className="ui column">
        <div className="inventario-section">
          <BasicMessage message={message} type={mgType} onClick={() => getInventario()} />
          <table className="ui compact table">
            <thead>
              <tr>
                <th>Cod. Cabys</th>
                <th>Cod. Producto</th>
                <th>Descripción</th>
                <th>U/Medida</th>
                <th>Precio Unidad</th>
                <th>Impuesto</th>
                <th className="editar-column">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {productos && productos.map((item) => (
                <tr key={item.Id}>
                  <td><span>{item.CodigoCabys}</span></td>
                  <td><span>{item.Codigo}</span></td>
                  <td><span>{item.Descripcion}</span></td>
                  <td><span>{getUnidad(item.UnidadMedida)}</span></td>
                  <td><NumberFormat value={item.PrecioUnitario} displayType={'text'} thousandSeparator={true} /></td>
                  <td><span>{`${item.Impuesto}%`}</span></td>
                  <td className="editar-column"><Icon onClick={() => setProducto({
                    ...item
                  })} className="editar-producto" name="edit" /></td>
                </tr>
              ))}
            </tbody>
            {renderPaging(inventarioState?.TotalRegistros)}
          </table>
        </div>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    inventarioState: state.inventarioState,
    emisorState: state.emisorState,
    errorState: state.errorState,
  };
}

export default connect(mapStateToProps, { logOut, getInventario, clearErrors })(Inventario);
